import axios from "axios";

const mode = import.meta.env.MODE;
// const environment = import.meta.env.VITE_ENVIRONMENT
const isDevelopment = mode === 'development';


// this functionn will create a base url based on the enviroment if the enviroment is in development mode then create a base url for development
// otherwise for production 
const createBaseURL = (host, port, suffix = '') => {
  const base = isDevelopment ? `http://${host}:${port}` : `https://${host}`;
  // const base = isDevelopment ? `http://${window.location.hostname}:${port}` : 'https://i-tips';
  return base;
};


// these are just a communication URL to get and save data 
// add also get the data in realtime 
export const baseURL = createBaseURL(import.meta.env.VITE_BACKEND_HOST, import.meta.env.VITE_BACKEND_PORT, 'baseURL');

// function kebabCase(str) {
//   return str.replace(/[A-Z]+/g, (match, offset) => (offset ? '-' : '') + match.toLowerCase());
// };


export const apiClient = axios.create({
  baseURL: baseURL,
  timeout: 100000,
  headers: { 'Content-Type': 'application/json' },
});

